import {
  useTranslation
} from "../../../../chunk-6N4NEKWU.mjs";
import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/ContentRenderer/ContentRenderer.tsx
import { useRef } from "react";
import { isStreamLive } from "../../../../domain/chat/index.mjs";
import { useSlideToFit } from "../../../../hooks/useSlideToFit.mjs";
import { Text } from "../../../primitive/index.mjs";
import { ChatMarkdown } from "../../ChatMarkdown/index.mjs";
import { CopyableCodesContext } from "../../ChatMarkdown/copyableCode.mjs";
import { preprocessStreamingContent } from "../../ChatMarkdown/streamingAnimation.mjs";
import { ShimmerText } from "../ShimmerText/index.mjs";
import { jsx } from "react/jsx-runtime";
function ContentRenderer({ content, isLastItem, sessionStatus, productMap, storeDomain, resolveLink }) {
  const { t } = useTranslation();
  const isInProgress = isStreamLive(sessionStatus);
  const isStreaming = Boolean(isLastItem && content && content.length > 0 && isInProgress);
  const className = `buyscout-timeline-content${isStreaming ? " streaming" : ""}`;
  const animateState = useRef({ charStartTimes: /* @__PURE__ */ new Map() });
  if (!isStreaming) {
    animateState.current.charStartTimes.clear();
  }
  const bubbleRef = useRef(null);
  useSlideToFit(bubbleRef, content, isStreaming);
  const showsMarkdown = isStreaming ? preprocessStreamingContent(content).trim() !== "" : Boolean(content);
  if (!content && !isInProgress) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { ref: bubbleRef, className, children: showsMarkdown ? /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(CopyableCodesContext, { value: true, children: /* @__PURE__ */ jsx(ChatMarkdown, { content, productMap, storeDomain, resolveLink, isStreaming, animateState: animateState.current }) }) }) : /* @__PURE__ */ jsx(ShimmerText, { children: /* @__PURE__ */ jsx(Text, { variant: "body", as: "span", italic: true, children: t("thinking.placeholder") }) }) });
}
export {
  ContentRenderer
};
//# sourceMappingURL=ContentRenderer.mjs.map